import { ca } from '@cian/analytics';
import { adAnalyticsCategory } from '../../scripts/services/analytics.service';

export function trackPhoneVerifyShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'show',
    label: 'phone_block',
  });
}

export function trackPhoneVerifyCodeSent() {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'sms_sent_to_phone',
    label: 'phone_block',
  });
}

export function trackPhoneVerifyConfirm() {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'send_sms_click',
    label: 'phone_block',
  });
}

export function trackPhoneVerifySuccess() {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'success',
    label: 'phone_block',
  });
}

export function trackPhoneVerifyError() {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'error',
    label: 'phone_block',
  });
}
